module.exports = __webpack_public_path__ + "media/images/athletes/1881-3f23dc28b275bc3e90ed4e61fe821a80.png";